/**
 * The stored answer key of a boggle: a few words found on the tray, proving it is playable.
 * Kept apart from the editor component so the eagerly loaded module never pulls the form in.
 */
import type { BoggleDefinition, BoggleSolution } from "./types";

export function emptySolution(_definition: BoggleDefinition): BoggleSolution {
  return { words: [] };
}

/** Reads whatever is stored, however wrong, and keeps the strings it can use. */
export function wordsOf(value: unknown): string[] {
  if (typeof value !== "object" || value === null || Array.isArray(value)) return [];
  const words = (value as Record<string, unknown>).words;
  return Array.isArray(words) ? words.filter((w): w is string => typeof w === "string") : [];
}
